import CommonAPIService from './CommonHandler';

// 1 Jul 2026 JCH: Gmail endpoints — shapes confirmed against nu-api.test.
// Response shapes confirmed live against nu-api.test:
//   GET  /api/gmail/mailboxes                                 -> [{ email, name, unread, total }]
//   GET  /api/gmail/mailboxes/:email/messages                 -> { messages:[{id,from,date,subject,snippet,read,hasAttachments}], nextPageToken, totalMessages, unreadMessages }
//   GET  /api/gmail/mailboxes/:email/messages/:id             -> { id,from,to,cc,date,subject,snippet,size,bodyPlain,bodyHtml,attachments:[{attachmentId,filename,mimeType,size,contentId?}] }
//   GET  /api/gmail/mailboxes/:email/messages/:id/attachments/:attId
//   DELETE /api/gmail/mailboxes/:email/messages/:id           -> trash
//   POST /api/gmail/mailboxes/:email/messages/:id/convert    -> { ...note, nid, files:[{ filename, file_description, ... }] }
//     body: { fid, status, staff?, re?, note?, attachments?: [{ attachmentId, filename, mimeType?, description? }] }
export class NuEmailAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  listMailboxes(router) {
    const url = '/api/gmail/mailboxes';
    return this.CommonAPIService.getCall(url, router);
  }

  listMessages(email, { maxResults = 100, pageToken = null } = {}, router) {
    const params = new URLSearchParams();
    if (maxResults) params.set('maxResults', String(maxResults));
    if (pageToken) params.set('pageToken', String(pageToken));
    const qs = params.toString();
    const url = `/api/gmail/mailboxes/${encodeURIComponent(email)}/messages${qs ? `?${qs}` : ''}`;
    return this.CommonAPIService.getCall(url, router);
  }

  getMessage(email, messageId, router) {
    const url = `/api/gmail/mailboxes/${encodeURIComponent(email)}/messages/${encodeURIComponent(messageId)}`;
    return this.CommonAPIService.getCall(url, router);
  }

  trashMessage(email, messageId, router) {
    const url = `/api/gmail/mailboxes/${encodeURIComponent(email)}/messages/${encodeURIComponent(messageId)}`;
    return this.CommonAPIService.deleteCall(url, router);
  }

  /** 8 Aug 2026 JCH: server creates email-in note + firm files (no browser re-upload). */
  convertMessage(email, messageId, body, router) {
    const url = `/api/gmail/mailboxes/${encodeURIComponent(email)}/messages/${encodeURIComponent(messageId)}/convert`;
    return this.CommonAPIService.postCall(url, body || {}, router);
  }
}

export default NuEmailAPIService;
